"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    cancel: 'Cancel',
    pleaseWait: 'Please wait...',
    errorOccurred: 'An Error Occurred',
};
